import React from 'react';
import { useIntl } from 'react-intl';
export default function NoResultsMessage(_a) {
    var id = _a.id;
    var intl = useIntl();
    return React.createElement("div", { className: "no-results" }, intl.formatMessage({ id: id }));
}
